Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Market", {
    enumerable: true,
    get: function() {
        return Market;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Market {
    findCountryByCode(code) {
        return this.countryLookups.get(code.toLowerCase());
    }
    resolveCountryByCode(code) {
        return this.findCountryByCode(code) ?? this.defaultCountry;
    }
    findCurrencyByCode(code) {
        return this.currencyLookups.get(code.toLowerCase());
    }
    getCurrencies() {
        return this.defaultCountry.currencies;
    }
    // eslint-disable-next-line max-statements
    constructor(marketDef, allCountries){
        _define_property(this, "uid", void 0);
        _define_property(this, "marketLocale", void 0);
        _define_property(this, "translationLocale", void 0);
        _define_property(this, "description", void 0);
        _define_property(this, "descriptionEnglish", void 0);
        _define_property(this, "taxesFeesDisplay", void 0);
        _define_property(this, "explicitConsent", void 0);
        _define_property(this, "internal", void 0);
        _define_property(this, "lang", void 0);
        _define_property(this, "langFallback", void 0);
        _define_property(this, "htmlDir", void 0);
        _define_property(this, "hrefLang", void 0);
        _define_property(this, "countries", void 0);
        _define_property(this, "defaultCountry", void 0);
        _define_property(this, "countryLookups", void 0);
        _define_property(this, "currencyLookups", void 0);
        this.uid = marketDef.uid;
        this.marketLocale = marketDef.marketLocale;
        this.translationLocale = marketDef.translationLocale;
        this.description = marketDef.description;
        this.descriptionEnglish = marketDef.descriptionEnglish;
        this.taxesFeesDisplay = marketDef.taxesFeesDisplay;
        this.explicitConsent = marketDef.explicitConsent;
        this.internal = marketDef.internal;
        this.lang = marketDef.lang;
        this.langFallback = marketDef.langFallback;
        this.htmlDir = marketDef.htmlDir;
        this.hrefLang = marketDef.hrefLang;
        this.countries = marketDef.countryUids.map((countryUid)=>allCountries.find((country)=>country.uid === countryUid));
        this.defaultCountry = this.countries.find((country)=>country.uid === marketDef.defaultCountryUid);
        this.countryLookups = new Map();
        this.currencyLookups = new Map();
        this.countries.forEach((country)=>{
            this.countryLookups.set(country.code.toLowerCase(), country);
            country.currencies.forEach((currency)=>{
                this.currencyLookups.set(currency.code.toLowerCase(), currency);
            });
        });
    }
}
